import React from 'react';

import SidebarTemplate from 'components/templates/SidebarTemplate';
import TimeOutputLayoutAddForm from 'components/organismos/master/attend/TimeOutputLayout/TimeOutputLayoutAddForm';

const TimeOutputLayoutAddPage: React.FC = () => {
  return (
    <SidebarTemplate>
      <TimeOutputLayoutAddForm />
    </SidebarTemplate>
  );
};

export default TimeOutputLayoutAddPage;
